import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Spin, message, Modal } from 'antd';
import { RegisterActions, TableActions } from '../../components';
import { MeasuringUpload } from '../';
import { RegisterMeasurementAdd } from '../../forms';
import PropTypes from 'prop-types';
import PropTypesImmutable from 'react-immutable-proptypes';
import * as actions from '../../actions/actionCreators/prodUnitMeasurementPointActionCreators';
import {
  getMeasurementList,
  getEntityMeteringPointsData,
} from '../../reducers/registerReducer';
import {
  getMeasuringUploadModal,
  hideMeasuringUploadModal,
  showMeasuringUploadModal,
} from '../../actions/actionCreators/modalsActionCreators';
import * as measurementSelectors from '../../reducers/prodUnitMeasurementPointReducer';
import MeasurementTable from '../../components/MeasurementTable/MeasurementTable';
import { getLoadingSelector } from '../../utils/asyncHelpers';
import { isNotRegistered } from '../../utils/meteringPointUtil';
import { generalFormFields } from '../../constants/formsAddEquipment';
import { formRegisterMeasurementFields } from '../../constants/formRegister';
import { meteringPointFields } from '../../constants/meteringPoint';
import { productionUnitFields } from '../../constants/productionUnit';
import {
  meteringPointType,
  meteringPointDataSource,
} from '../../constants/classificators';
import { List } from 'immutable';
import './RegisterMeasurement.css';
import {
  fetchMeasurementsActionCreator,
  resetMeasurementsActionCreator,
  resetProductionUnitMeasurementActionCreator,
} from '../../actions/actionCreators/registerActionCreators';

class RegisterMeasurement extends Component {
  static propTypes = {
    resetMeasurements: PropTypes.func.isRequired,
    resetProductionUnitMeasurement: PropTypes.func.isRequired,
    fetchMeasurements: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    measurements: PropTypesImmutable.list.isRequired,
    hideMeasurementForm: PropTypes.func.isRequired,
    showMeasurementForm: PropTypes.func.isRequired,
    fetchProductionUnitMeasurement: PropTypes.func.isRequired,
    fetchProductionUnitMeasurementPoints: PropTypes.func.isRequired,
    addMeasurementPointToProductionUnit: PropTypes.func.isRequired,
    removeMeasurementPointFromProductionUnit: PropTypes.func.isRequired,
    updateProductionUnitMeasurement: PropTypes.func.isRequired,
    selectMeasurement: PropTypes.func.isRequired,
    selectedMeasurementId: PropTypes.string,
    onSubmitSuccess: PropTypes.func,
    t: PropTypes.func.isRequired,
    hasPrevious: PropTypes.bool,
    hasDone: PropTypes.bool,
    goPrevious: PropTypes.func,

    legalEntityId: PropTypes.number.isRequired,
    productionUnit: PropTypesImmutable.map.isRequired,
    measurementFormVisible: PropTypes.bool.isRequired,
    deleteProductionUnitMeasurement: PropTypes.func.isRequired,
    onMetringFormSubmit: PropTypes.func.isRequired,
    isAdmin: PropTypes.bool.isRequired,
    isEditMode: PropTypes.bool.isRequired,
    inEditForNotAdmin: PropTypes.bool.isRequired,
    showRequestChangeModal: PropTypes.func,
    refreshProductionUnit: PropTypes.func,
    stateImportModal: PropTypes.bool.isRequired,
    hideImportModal: PropTypes.func.isRequired,
    showImportModal: PropTypes.func.isRequired,
  };

  state = {
    isAdding: false,
    isFormAvp: false,
    linkedMeasurementPoints: [],
    editData: null,
  };

  handleAddMeasurement = () => {
    this.setState({ editData: null });
    this.props.showMeasurementForm();
  };

  handleEditMeasurement = (data) => {
    this.setState({ editData: data?.toJS ? data.toJS() : data });
    this.props.showMeasurementForm();
  };

  handleCloseForm = () => {
    this.setState({ editData: null });
    this.props.hideMeasurementForm();
  };

  handleMeasurementSubmit = (values) =>
    this.props.onMetringFormSubmit(values, this.handleCloseForm);

  handleEditCloseForm = () => {
    this.props.hideMeasurementForm();
    this.fetchLinkedMeasurementPoints();
    if (this.props.refreshProductionUnit) this.props.refreshProductionUnit();
  };

  componentDidUpdate(prevProps, prevState) {
    const {
      fetchMeasurements,
      productionUnit,
      legalEntityId,
      fetchProductionUnitMeasurement,
    } = this.props;

    if (this.state.isAdding && !prevState.isAdding) {
      fetchMeasurements(legalEntityId);
    }

    if (!this.state.isAdding && prevState.isAdding) {
      const puId = productionUnit.get(generalFormFields.ID);
      if (puId) {
        fetchProductionUnitMeasurement(puId);
      }
      this.fetchLinkedMeasurementPoints();
    }

    if (!prevProps.isEditMode && this.props.isEditMode) {
      this.fetchLinkedMeasurementPoints();
    }

    if (
      this.props.isEditMode &&
      prevProps.productionUnit &&
      this.props.productionUnit &&
      prevProps.productionUnit.get(productionUnitFields.STATUS) !==
        this.props.productionUnit.get(productionUnitFields.STATUS)
    ) {
      this.fetchLinkedMeasurementPoints();
    }
  }

  handleIsAdding = () => {
    this.props.selectMeasurement('0');
    this.setState({ isAdding: true });
  };

  handleUnlinkClick = async (measurementPointId) => {
    const {
      productionUnit,
      removeMeasurementPointFromProductionUnit,
      refreshProductionUnit,
    } = this.props;
    const result = await removeMeasurementPointFromProductionUnit({
      productionUnitId: productionUnit.get(generalFormFields.ID),
      measurementPointId,
    });
    if (result?.error) return;
    this.fetchLinkedMeasurementPoints();
    if (refreshProductionUnit) await refreshProductionUnit();
  };

  componentDidMount() {
    const {
      resetMeasurements,
      resetProductionUnitMeasurement,
      isEditMode,
      fetchMeasurements,
      legalEntityId,
    } = this.props;
    resetMeasurements();
    resetProductionUnitMeasurement();
    const { fetchProductionUnitMeasurement, productionUnit } = this.props;
    const productionUnitId = productionUnit.get(generalFormFields.ID);

    if (productionUnitId) {
      fetchProductionUnitMeasurement(productionUnitId);
    }

    this.fetchLinkedMeasurementPoints();

    if (!isEditMode) {
      fetchMeasurements(legalEntityId);
    }
  }

  fetchLinkedMeasurementPoints = async () => {
    const { fetchProductionUnitMeasurementPoints, productionUnit } = this.props;
    const puId = productionUnit.get(generalFormFields.ID);
    if (!puId) return;
    try {
      const result = await fetchProductionUnitMeasurementPoints(puId);
      if (result?.entities) {
        const entities = result.entities.measurement || {};
        this.setState({
          linkedMeasurementPoints: Object.values(entities),
        });
      }
    } catch (e) {
      console.error('Failed to fetch linked measurement points', e);
    }
  };

  findSelectedMeteringPoint() {
    const { selectedMeasurementId, t, measurements } = this.props;

    if (!selectedMeasurementId || selectedMeasurementId === '0') {
      message.error(t('measurement.warningBody'));
      return null;
    }

    let meteringPoint = measurements.find(
      (m) => m.get(meteringPointFields.ID) === selectedMeasurementId
    );
    if (!meteringPoint) {
      meteringPoint = measurements.find(
        (m) => m.get(meteringPointFields.EICZ_CODE) === selectedMeasurementId
      );
    }

    if (!meteringPoint) {
      message.error(t('measurement.warningBody'));
      return null;
    }

    return meteringPoint;
  }

  /**
   * Points that AVP knows but BMR does not carry a placeholder id that must not be sent back, so
   * it is dropped and the point is saved as a new one belonging to this production unit.
   */
  linkToProductionUnit(meteringPoint) {
    const { productionUnit } = this.props;

    const point = isNotRegistered(meteringPoint.get(meteringPointFields.ID))
      ? meteringPoint.delete(meteringPointFields.ID)
      : meteringPoint;

    return point.merge({
      [meteringPointFields.PRODUCTION_UNIT_ID]: productionUnit.get(
        productionUnitFields.ID
      ),
      [meteringPointFields.LEGAL_ENTITY_ID]: productionUnit.get(
        productionUnitFields.LEGAL_ENTITY_ID
      ),
    });
  }

  /**
   * A point AVP knows but BMR does not has no id to link and no details view to open, so it is
   * created through the inline form, which collects the missing dissemination level.
   */
  openMeasurementForm(meteringPoint) {
    this.setState({
      isFormAvp:
        meteringPoint.get(meteringPointFields.DATA_SOURCE) ===
        meteringPointDataSource.AVP,
    });
    this.handleEditMeasurement(this.linkToProductionUnit(meteringPoint));
  }

  // Edit mode: administrator links an already eligible point.
  async goAdd() {
    const { productionUnit, addMeasurementPointToProductionUnit } = this.props;

    const meteringPoint = this.findSelectedMeteringPoint();
    if (!meteringPoint) return;

    if (isNotRegistered(meteringPoint.get(meteringPointFields.ID))) {
      this.openMeasurementForm(meteringPoint);
      return;
    }

    const productionUnitId = productionUnit.get(generalFormFields.ID);
    const measurementPointId = meteringPoint.get(meteringPointFields.ID);

    const result = await addMeasurementPointToProductionUnit({
      productionUnitId,
      measurementPointId,
    });
    if (result?.error) return;

    this.setState({ isAdding: false });
    this.fetchLinkedMeasurementPoints();
    if (this.props.refreshProductionUnit)
      await this.props.refreshProductionUnit();
  }

  /**
   * Registration wizard: the producer links the point himself, so the dissemination level has to be
   * collected in the form before it can be saved.
   */
  async goAddRegistration() {
    const { updateProductionUnitMeasurement } = this.props;

    const meteringPoint = this.findSelectedMeteringPoint();
    if (!meteringPoint) return;

    if (meteringPoint.get(meteringPointFields.DISSEMINATION_LEVEL)) {
      const result = await updateProductionUnitMeasurement(
        this.linkToProductionUnit(meteringPoint).toJS()
      );
      if (result?.error) return;
      this.setState({ isAdding: false });
      this.fetchLinkedMeasurementPoints();
      return;
    }

    this.openMeasurementForm(meteringPoint);
  }

  renderLinkedMeasurementTable() {
    const {
      t,
      isAdmin,
      isLoading,
      productionUnit,
      deleteProductionUnitMeasurement,
      showImportModal,
    } = this.props;
    const { linkedMeasurementPoints } = this.state;

    return (
      <MeasurementTable
        t={t}
        data={linkedMeasurementPoints}
        onSelectMeasurement={() => {}}
        selectedMeasurementId={null}
        onDeleteClick={deleteProductionUnitMeasurement}
        isAdmin={isAdmin}
        isEditMode={true}
        isLoading={isLoading}
        showImportModal={showImportModal}
        isAdminEdit={false}
        showProductionColumns={true}
        productionUnitId={productionUnit.get(productionUnitFields.ID)}
        onUnlinkClick={isAdmin ? this.handleUnlinkClick : undefined}
      />
    );
  }

  renderImportModal() {
    const { t, stateImportModal, hideImportModal, productionUnit } = this.props;

    if (!stateImportModal) return null;

    return (
      <Modal
        onCancel={hideImportModal}
        open={stateImportModal}
        footer={false}
        title={t('productionUnit.importTitle')}
        width="600px"
      >
        <MeasuringUpload
          onComplete={hideImportModal}
          productionUnitId={productionUnit.get(generalFormFields.ID)}
        />
      </Modal>
    );
  }

  renderMeasurementForm(closeFormHandler, isAvp) {
    const { t, productionUnit, inEditForNotAdmin, isAdmin } = this.props;

    return (
      <RegisterMeasurementAdd
        productionUnitId={productionUnit.get(generalFormFields.ID)}
        closeForm={closeFormHandler}
        initialValues={this.state.editData || {}}
        onSubmit={(values) =>
          this.props.onMetringFormSubmit(
            {
              ...values,
              [formRegisterMeasurementFields.PRODUCTION_UNIT_ID]:
                productionUnit.get(generalFormFields.ID),
            },
            closeFormHandler
          )
        }
        t={t}
        inEditForNotAdmin={inEditForNotAdmin}
        isAdmin={isAdmin}
        isAvp={isAvp}
        isProduction
      />
    );
  }

  renderAddingContent({
    isEditModeTable,
    checkEligibility,
    onSaveClick,
    closeFormHandler,
  }) {
    const {
      t,
      isAdmin,
      isLoading,
      productionUnit,
      measurementFormVisible,
      deleteProductionUnitMeasurement,
      measurements,
      selectMeasurement,
      selectedMeasurementId,
      showImportModal,
    } = this.props;
    const { linkedMeasurementPoints, isFormAvp } = this.state;

    const linkedIds = new Set(
      linkedMeasurementPoints.map((mp) => mp[meteringPointFields.ID])
    );
    const availableData = measurements
      .toJS()
      .filter(
        (mp) =>
          mp[meteringPointFields.METERING_POINT_TYPE] !==
            meteringPointType.CONSUMPTION &&
          !linkedIds.has(mp[meteringPointFields.ID])
      );

    return (
      <div className="register-measurement-container">
        <h2 className="register-measurement-container__subtitle">
          {t('measurement.title')}
        </h2>
        <MeasurementTable
          t={t}
          data={availableData}
          onSelectMeasurement={selectMeasurement}
          selectedMeasurementId={selectedMeasurementId}
          onDeleteClick={deleteProductionUnitMeasurement}
          isAdmin={isAdmin}
          isEditMode={isEditModeTable}
          isLoading={isLoading}
          showImportModal={showImportModal}
          isAdminEdit={true}
          checkEligibility={checkEligibility}
          showProductionColumns={true}
          productionUnitId={productionUnit.get(productionUnitFields.ID)}
        />
        {measurementFormVisible ? (
          this.renderMeasurementForm(closeFormHandler, isFormAvp)
        ) : (
          <TableActions>
            <Button
              onClick={() => {
                this.props.selectMeasurement('0');
                this.setState({ isAdding: false });
              }}
              size="large"
              style={{ marginRight: 8 }}
            >
              {t('measurement.buttonBack')}
            </Button>
            <Button
              onClick={this.handleAddMeasurement}
              size="large"
              type="primary"
              style={{ marginRight: 8 }}
            >
              {t('measurement.buttonAdd')}
            </Button>
            <Button onClick={onSaveClick} type="primary" size="large">
              {t('measurement.buttonSave')}
            </Button>
          </TableActions>
        )}
      </div>
    );
  }

  renderEditModeContent() {
    const { t, isAdmin, measurementFormVisible, hideMeasurementForm } =
      this.props;
    const { isAdding } = this.state;

    if (isAdding) {
      return this.renderAddingContent({
        isEditModeTable: true,
        checkEligibility: true,
        onSaveClick: () => this.goAdd(),
        closeFormHandler: async () => {
          hideMeasurementForm();
          this.setState({ isAdding: false, isFormAvp: false });
          this.fetchLinkedMeasurementPoints();
          if (this.props.refreshProductionUnit)
            this.props.refreshProductionUnit();
        },
      });
    }

    // Default view: linked MPs table + buttons (or edit form if active)
    return (
      <div className="register-measurement-container">
        <h2 className="register-measurement-container__subtitle">
          {t('measurement.titleEdit')}
        </h2>
        {this.renderLinkedMeasurementTable()}
        {measurementFormVisible
          ? this.renderMeasurementForm(this.handleEditCloseForm)
          : isAdmin && (
              <TableActions>
                <Button
                  onClick={this.handleIsAdding}
                  type="primary"
                  size="large"
                >
                  {t('measurement.buttonAddExisting')}
                </Button>
              </TableActions>
            )}
      </div>
    );
  }

  render() {
    const {
      hasPrevious,
      hasDone,
      goPrevious,
      t,
      isLoading,
      productionUnit,
      isEditMode,
      isAdmin,
      showRequestChangeModal,
      hideMeasurementForm,
    } = this.props;

    if (isEditMode) {
      return (
        <Spin spinning={isLoading}>
          {this.renderEditModeContent()}
          {this.renderImportModal()}
        </Spin>
      );
    }

    const { isAdding } = this.state;

    if (isAdding) {
      return (
        <Spin spinning={isLoading}>
          {this.renderAddingContent({
            isEditModeTable: false,
            onSaveClick: () => this.goAddRegistration(),
            closeFormHandler: async () => {
              hideMeasurementForm();
              this.setState({ isAdding: false, isFormAvp: false });
              this.fetchLinkedMeasurementPoints();
              const puId = productionUnit.get(generalFormFields.ID);
              if (puId) {
                this.props.fetchProductionUnitMeasurement(puId);
              }
              this.props.fetchMeasurements(this.props.legalEntityId);
              if (this.props.refreshProductionUnit)
                this.props.refreshProductionUnit();
            },
          })}
        </Spin>
      );
    }

    // Default view: linked MPs + add/next buttons
    return (
      <Spin spinning={isLoading}>
        <div className="register-measurement-container">
          <h2 className="register-measurement-container__subtitle">
            {t('measurement.title')}
          </h2>
          {this.renderLinkedMeasurementTable()}
          <TableActions>
            <Button
              onClick={this.handleIsAdding}
              type="primary"
              size="large"
              style={{ marginRight: 8 }}
            >
              {t('measurement.buttonAddExisting')}
            </Button>
          </TableActions>
          <RegisterActions
            showRequestChangeModal={showRequestChangeModal}
            hasPrevious={hasPrevious}
            hasDone={hasDone}
            goPrevious={goPrevious}
            goNext={() => {
              if (this.props.onSubmitSuccess) {
                this.props.onSubmitSuccess();
              }
            }}
            isEditMode={isEditMode}
            isAdmin={isAdmin}
            showSaveButton={!isEditMode || isAdmin}
            t={t}
          />
        </div>
        {this.renderImportModal()}
      </Spin>
    );
  }
}

const isLoading = getLoadingSelector(
  getMeasurementList,
  measurementSelectors.getMeteringPoint
);

const mapStateToProps = (state) => {
  const measurementList = getEntityMeteringPointsData(state);
  const rawProdMeasurements = measurementSelectors.getMeteringPointData(state);
  const prodMeasurements = List.isList(rawProdMeasurements)
    ? rawProdMeasurements
    : List();

  const linkedEiczCodes = new Set(
    prodMeasurements.map((mp) => mp.get(meteringPointFields.EICZ_CODE)).toJS()
  );

  let measurements = measurementList.filter(
    (item) => !linkedEiczCodes.has(item.get(meteringPointFields.EICZ_CODE))
  );

  prodMeasurements.forEach((mp) => {
    if (mp.size !== 0 && mp.get(meteringPointFields.ADDRESS) !== undefined) {
      measurements = measurements.push(mp);
    }
  });

  measurements = measurements.filter((v, i) => {
    return (
      measurements
        .map((val) => val.get(meteringPointFields.EICZ_CODE))
        .indexOf(v.get(meteringPointFields.EICZ_CODE)) === i
    );
  });

  const measurementFormVisible =
    measurementSelectors.getProdUnitMeasurementFormState(state);
  const selectedMeasurementId =
    measurementSelectors.getProdUnitSelectedMeasurement(state);

  return {
    selectedMeasurementId,
    isLoading: isLoading(state),
    measurements,
    measurementFormVisible,
    stateImportModal: getMeasuringUploadModal(state),
  };
};

const mapDispatchToProps = {
  resetMeasurements: resetMeasurementsActionCreator,
  resetProductionUnitMeasurement: resetProductionUnitMeasurementActionCreator,
  fetchMeasurements: fetchMeasurementsActionCreator,
  showImportModal: showMeasuringUploadModal,
  hideImportModal: hideMeasuringUploadModal,
  ...actions,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(RegisterMeasurement);
